(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    if (window.__MORMORS_BUILDER_V1__) return;
    window.__MORMORS_BUILDER_V1__ = true;

    const modal = document.getElementById('custom-modal');
    const trigger = document.getElementById('customize-trigger');
    const closeBtn = document.getElementById('close-modal');
    const saveBtn = document.getElementById('save-customization');
    const postButtons = document.getElementById('post-custom-buttons');
    const addAnotherBtn = document.getElementById('add-another');
    const addToCartBtn = document.getElementById('real-add-to-cart');
    const layoutUIRoot = document.getElementById('layout-ui-root');
    const slotEditorRoot = document.getElementById('slot-editor-root');
    const layoutSelect = document.getElementById('custom-layout');
    const priceEl = document.getElementById('custom-total-price');
    const savedCounter = document.getElementById('saved-counter');

    if (!modal || !trigger || !saveBtn || !layoutUIRoot || !slotEditorRoot) return;

    const productData = window.productData || {};
    const PRODUCT_TITLE = productData.title || 'Custom Shirt';
    const PRODUCT_IMAGE = productData.image || '';
    const VARIANT_ID = Number(productData.variantId || 0);
    const BASE_PRICE = Number(productData.price || 19.99);

    const previews = {
      front: {
        card: document.getElementById('shirt-container-front')?.closest('.mm-preview-card') || null,
        image: document.getElementById('shirt-preview-front'),
        stage: document.getElementById('shirt-container-front')
      },
      back: {
        card: document.getElementById('shirt-container-back')?.closest('.mm-preview-card') || null,
        image: document.getElementById('shirt-preview-back'),
        stage: document.getElementById('shirt-container-back')
      },
      leftSleeve: {
        card: document.getElementById('left-sleeve-card'),
        image: document.getElementById('left-sleeve-img'),
        stage: document.getElementById('left-sleeve-img')?.parentElement || null
      },
      rightSleeve: {
        card: document.getElementById('right-sleeve-card'),
        image: document.getElementById('right-sleeve-img'),
        stage: document.getElementById('right-sleeve-img')?.parentElement || null
      }
    };

    const sleeveRow = document.getElementById('sleeve-preview-row');

    const previewTargets = {
      front_left: document.getElementById('front-left-preview'),
      front_right: document.getElementById('front-right-preview'),
      front_center: document.getElementById('front-center-preview'),
      back_center: document.getElementById('back-center-preview'),
      back_upper: document.getElementById('back-upper-preview'),
      sleeve_left: document.getElementById('left-sleeve-preview'),
      sleeve_right: document.getElementById('right-sleeve-preview')
    };

    const SHIRT_MOCKUPS = {
      black: {
        front: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-black-front.png?v=1775686479',
        back: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-black-back.png?v=1775686500',
        leftSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-black-left-sleeve.png?v=1775686525',
        rightSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-black-right-sleeve.png?v=1775686542'
      },
      blue: {
        front: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-blue-front.png?v=1775686479',
        back: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-blue-back.png?v=1775686501',
        leftSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-blue-left-sleeve.png?v=1775686525',
        rightSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-blue-right-sleeve.png?v=1775686543'
      },
      green: {
        front: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-green-front.png?v=1775686479',
        back: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-green-back.png?v=1775686500',
        leftSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-green-left-sleeve.png?v=1775686524',
        rightSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-green-right-sleeve.png?v=1775686542'
      },
      grey: {
        front: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-grey-front.png?v=1775686480',
        back: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-grey-back.png?v=1775686501',
        leftSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-grey-left-sleeve.png?v=1775686525',
        rightSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-grey-right-sleeve.png?v=1775686543'
      },
      pink: {
        front: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-pink-front.png?v=1775686480',
        back: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-pink-back.png?v=1775686502',
        leftSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-pink-left-sleeve.png?v=1775686525',
        rightSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-pink-right-sleeve.png?v=1775686543'
      },
      red: {
        front: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-red-front.png?v=1775686479',
        back: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-red-back.png?v=1775686501',
        leftSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-red-left-sleeve.png?v=1775686525',
        rightSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-red-right-sleeve.png?v=1775686544'
      },
      white: {
        front: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-white-front.png?v=1775686480',
        back: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-white-back.png?v=1775686502',
        leftSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-white-left-sleeve.png?v=1775686525',
        rightSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-white-right-sleeve.png?v=1775686543'
      },
      yellow: {
        front: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-yellow-front.png?v=1775686480',
        back: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-yellow-back.png?v=1775686501',
        leftSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-yellow-left-sleeve.png?v=1775686525',
        rightSleeve: 'https://cdn.shopify.com/s/files/1/0837/8640/0057/files/shirt-yellow-right-sleeve.png?v=1775686543'
      }
    };

    const PRINT_ZONES = {
      front_left: { x: 27.2, y: 20.2, w: 17, h: 16.5, scaleMin: 70, scaleMax: 115, scaleDefault: 100, view: 'front' },
      front_right: { x: 55.8, y: 20.2, w: 17, h: 16.5, scaleMin: 70, scaleMax: 115, scaleDefault: 100, view: 'front' },
      front_center: { x: 27, y: 20, w: 46, h: 46, scaleMin: 55, scaleMax: 240, scaleDefault: 100, view: 'front', dragMinY: 8, dragMaxY: 42 },
      back_center: { x: 27, y: 19, w: 46, h: 48, scaleMin: 55, scaleMax: 240, scaleDefault: 100, view: 'back', dragMinY: 7, dragMaxY: 42 },
      back_upper: { x: 36, y: 11.2, w: 28, h: 11, scaleMin: 70, scaleMax: 115, scaleDefault: 100, view: 'back' },
      sleeve_left: { x: 52, y: 26, w: 26, h: 15, scaleMin: 65, scaleMax: 135, scaleDefault: 100, view: 'leftSleeve' },
      sleeve_right: { x: 26, y: 26, w: 26, h: 15, scaleMin: 65, scaleMax: 135, scaleDefault: 100, view: 'rightSleeve' }
    };

    const SLOT_META = {
      front_left: { label: 'Left Chest', baseWidth: 75, baseHeight: 75 },
      front_right: { label: 'Right Chest', baseWidth: 75, baseHeight: 75 },
      front_center: { label: 'Center Front', baseWidth: 140, baseHeight: 140 },
      back_center: { label: 'Back Center', baseWidth: 140, baseHeight: 140 },
      back_upper: { label: 'Upper Back Small', baseWidth: 90, baseHeight: 55 },
      sleeve_left: { label: 'Left Sleeve', baseWidth: 70, baseHeight: 70 },
      sleeve_right: { label: 'Right Sleeve', baseWidth: 70, baseHeight: 70 }
    };

    const BASE_LAYOUT_SLOTS = {
      left: ['front_left'],
      right: ['front_right'],
      center: ['front_center'],
      'left-right': ['front_left', 'front_right'],
      'back-center': ['back_center'],
      'back-upper': ['back_upper'],
      'front-back-center': ['front_center', 'back_center'],
      'left-back-center': ['front_left', 'back_center'],
      'right-back-center': ['front_right', 'back_center'],
      'front-back-upper': ['front_center', 'back_upper']
    };

    const LAYOUT_GROUPS = {
      front: [
        ['left', 'Left Chest'],
        ['right', 'Right Chest'],
        ['center', 'Center Front'],
        ['left-right', 'Left + Right Chest']
      ],
      back: [
        ['back-center', 'Back Center'],
        ['back-upper', 'Upper Back Small']
      ],
      'front-back': [
        ['front-back-center', 'Front Center + Back Center'],
        ['left-back-center', 'Left Chest + Back Center'],
        ['right-back-center', 'Right Chest + Back Center'],
        ['front-back-upper', 'Front Center + Upper Back']
      ],
      sleeves: [
        ['sleeve-left', 'Left Sleeve'],
        ['sleeve-right', 'Right Sleeve'],
        ['sleeve-both', 'Left + Right Sleeves'],
        ['sleeve-none', 'Remove Sleeves']
      ]
    };

    const FONT_OPTIONS = [
      ['Arial Black, Arial, sans-serif', 'Bold Sans'],
      ["Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif", 'Athletic Block'],
      ["'Trebuchet MS', sans-serif", 'Clean Sans'],
      ["'Verdana', sans-serif", 'Rounded Sans'],
      ["'Georgia', serif", 'Classic Serif'],
      ["'Brush Script MT', cursive", 'Script']
    ];

    const COLORS = ['#000000', '#ffffff', '#d62828', '#1d4ed8', '#0f172a', '#f4b400', '#16a34a', '#ec4899'];
    const OUTLINE_COLORS = ['#ffffff', '#000000', '#d62828', '#1d4ed8', '#f4b400'];
    const SHIRT_COLOR_OPTIONS = [
      ['white', 'White', '#ffffff'],
      ['black', 'Black', '#111111'],
      ['grey', 'Grey', '#8f8f8f'],
      ['red', 'Red', '#d62828'],
      ['blue', 'Blue', '#2f5fba'],
      ['pink', 'Pink', '#f4a7bd'],
      ['green', 'Green', '#4f8a5f'],
      ['yellow', 'Yellow', '#f4c542']
    ];
    const SHIRT_SIZE_OPTIONS = [
      'Toddler 2T',
      'Toddler 3T',
      'Toddler 4T',
      'Youth XS',
      'Youth S',
      'Youth M',
      'Youth L',
      'Youth XL',
      'Adult S',
      'Adult M',
      'Adult L',
      'Adult XL',
      'Adult 2XL',
      'Adult 3XL'
    ];
    const BUILDER_STEPS = [
      ['Color & Size', 'Choose the shirt'],
      ['Print Layout', 'Pick positions'],
      ['Customize', 'Text or artwork'],
      ['Review', 'Coming later'],
      ['Save', 'Coming later']
    ];

    let savedItems = [];
    let builder = createEmptyBuilderState();
    let drag = null;
    let sleeveZoomView = '';
    let lastMockupColor = '';
    let resizeFrame = 0;

    function createEmptyBuilderState() {
      return {
        step: 1,
        color: '',
        size: '',
        openGroup: '',
        baseLayout: '',
        sleeves: [],
        activeSlot: '',
        activeView: 'front',
        slots: {}
      };
    }

    function defaultSlotState(slotKey) {
      const zone = PRINT_ZONES[slotKey];
      return {
        type: '',
        text: '',
        image: '',
        file: null,
        fileName: '',
        font: 'Arial Black, Arial, sans-serif',
        color: '#000000',
        outlineEnabled: false,
        outlineColor: '#ffffff',
        scale: zone?.scaleDefault || 100,
        rotation: 0,
        offsetY: 0,
        objects: [],
        selectedId: ''
      };
    }

    const FIXED_SIZE_SLOTS = new Set(['front_left', 'front_right', 'back_upper']);
    let designObjectCounter = 1;
    let pointerSession = null;

    function nextObjectId() {
      designObjectCounter += 1;
      return `mm-object-${Date.now()}-${designObjectCounter}`;
    }

    function createDesignObject(type, slotKey) {
      const zone = PRINT_ZONES[slotKey] || {};
      return {
        id: nextObjectId(),
        type: type === 'logo' ? 'logo' : 'text',
        text: type === 'logo' ? '' : 'Your text',
        image: '',
        file: null,
        fileName: '',
        font: 'Arial Black, Arial, sans-serif',
        color: '#000000',
        outlineEnabled: false,
        outlineColor: '#ffffff',
        scale: FIXED_SIZE_SLOTS.has(slotKey) ? 100 : (zone.scaleDefault || 100),
        rotation: 0,
        x: 50,
        y: 50
      };
    }

    function normalizeSlotState(slotKey, rawState) {
      const state = rawState || defaultSlotState(slotKey);
      if (!Array.isArray(state.objects)) {
        state.objects = [];
        const hasLegacyText = state.type === 'text' && String(state.text || '').trim();
        const hasLegacyLogo = state.type === 'logo' && (state.image || state.file);
        if (hasLegacyText || hasLegacyLogo) {
          const object = createDesignObject(state.type, slotKey);
          object.text = state.text || object.text;
          object.image = state.image || '';
          object.file = state.file || null;
          object.fileName = state.fileName || '';
          object.font = state.font || object.font;
          object.color = state.color || object.color;
          object.outlineEnabled = Boolean(state.outlineEnabled);
          object.outlineColor = state.outlineColor || object.outlineColor;
          object.scale = FIXED_SIZE_SLOTS.has(slotKey) ? 100 : Number(state.scale || object.scale);
          object.rotation = Number(state.rotation || 0);
          object.x = 50;
          object.y = clamp(50 + Number(state.offsetY || 0), 5, 95);
          state.objects.push(object);
          state.selectedId = object.id;
        }
      }
      if (state.objects.length && !state.objects.some(function (object) { return object.id === state.selectedId; })) {
        state.selectedId = state.objects[0].id;
      }
      if (!state.objects.length) state.selectedId = '';
      state.objects.forEach(function (object) {
        if (!object.id) object.id = nextObjectId();
        if (object.x == null) object.x = 50;
        if (object.y == null) object.y = 50;
        if (object.scale == null) object.scale = FIXED_SIZE_SLOTS.has(slotKey) ? 100 : (PRINT_ZONES[slotKey]?.scaleDefault || 100);
        if (FIXED_SIZE_SLOTS.has(slotKey)) object.scale = 100;
        object.rotation = snapRotation(object.rotation || 0);
      });
      builder.slots[slotKey] = state;
      return state;
    }

    function selectedObject(slotKey) {
      const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
      return state.objects.find(function (object) { return object.id === state.selectedId; }) || null;
    }

    function validDesignObject(object) {
      if (!object) return false;
      if (object.type === 'text') return Boolean(String(object.text || '').trim());
      return Boolean(object.type === 'logo' && object.file && object.image);
    }

    function objectDimensions(slotKey, object) {
      const meta = SLOT_META[slotKey];
      const scale = Number(object?.scale || 100) / 100;
      return {
        width: Math.max(24, Math.round(meta.baseWidth * scale)),
        height: Math.max(24, Math.round(meta.baseHeight * scale))
      };
    }

    function clampObjectPosition(slotKey, object, targetElement) {
      const target = targetElement || previewTargets[slotKey];
      if (!target || !object) return;
      const zoneRect = target.getBoundingClientRect();
      if (!zoneRect.width || !zoneRect.height) {
        object.x = clamp(object.x, 5, 95);
        object.y = clamp(object.y, 5, 95);
        return;
      }
      const dims = objectDimensions(slotKey, object);
      const radians = Math.abs(Number(object.rotation || 0)) * Math.PI / 180;
      const rotatedWidth = Math.abs(dims.width * Math.cos(radians)) + Math.abs(dims.height * Math.sin(radians));
      const rotatedHeight = Math.abs(dims.width * Math.sin(radians)) + Math.abs(dims.height * Math.cos(radians));
      const halfX = Math.min(49, (rotatedWidth / zoneRect.width) * 50);
      const halfY = Math.min(49, (rotatedHeight / zoneRect.height) * 50);
      object.x = clamp(Number(object.x || 50), halfX, 100 - halfX);
      object.y = clamp(Number(object.y || 50), halfY, 100 - halfY);
    }

    function fitObjectToSlot(slotKey, object) {
      if (!object) return;
      if (FIXED_SIZE_SLOTS.has(slotKey)) object.scale = 100;
      else object.scale = PRINT_ZONES[slotKey]?.scaleDefault || 100;
      object.x = 50;
      object.y = 50;
      object.rotation = 0;
      clampObjectPosition(slotKey, object);
    }

    function syncLegacyFields(slotKey) {
      const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
      const object = state.objects[0] || null;
      if (!object) {
        state.type = '';
        state.text = '';
        state.image = '';
        state.file = null;
        state.fileName = '';
        return;
      }
      state.type = object.type;
      state.text = object.text || '';
      state.image = object.image || '';
      state.file = object.file || null;
      state.fileName = object.fileName || '';
      state.font = object.font || state.font;
      state.color = object.color || state.color;
      state.outlineEnabled = Boolean(object.outlineEnabled);
      state.outlineColor = object.outlineColor || state.outlineColor;
      state.scale = Number(object.scale || 100);
      state.rotation = Number(object.rotation || 0);
      state.offsetY = Number(object.y || 50) - 50;
    }


    function activeSlots() {
      const base = builder.baseLayout ? (BASE_LAYOUT_SLOTS[builder.baseLayout] || []) : [];
      return Array.from(new Set(base.concat(builder.sleeves)));
    }

    function layoutGroupForBaseLayout(layout) {
      if (!layout) return 'front';
      if (['left', 'right', 'center', 'left-right'].includes(layout)) return 'front';
      if (['back-center', 'back-upper'].includes(layout)) return 'back';
      if (['front-back-center', 'left-back-center', 'right-back-center', 'front-back-upper'].includes(layout)) return 'front-back';
      return 'front';
    }

    function currentMainLayoutGroup() {
      if (builder.openGroup && builder.openGroup !== 'sleeves') return builder.openGroup;
      return layoutGroupForBaseLayout(builder.baseLayout);
    }

    function areaSummaryLabels() {
      return activeSlots().map(function (slotKey) {
        return SLOT_META[slotKey].label;
      });
    }

    function ensureActiveSlotStates() {
      const current = activeSlots();
      current.forEach(function (slotKey) {
        normalizeSlotState(slotKey, builder.slots[slotKey] || defaultSlotState(slotKey));
      });
      if (!builder.activeSlot || !current.includes(builder.activeSlot)) {
        builder.activeSlot = current[0] || '';
      }
      if (builder.activeSlot) builder.activeView = PRINT_ZONES[builder.activeSlot].view;
    }

    function esc(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
      });
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, Number(value)));
    }

    function pxToInches(px) {
      return (Number(px) / 37.8).toFixed(1);
    }

    function snapRotation(value) {
      return Math.round(Number(value || 0) / 15) * 15;
    }

    function slotDimensions(slotKey) {
      const meta = SLOT_META[slotKey];
      const state = builder.slots[slotKey] || defaultSlotState(slotKey);
      const scale = Number(state.scale || 100) / 100;
      return {
        width: Math.round(meta.baseWidth * scale),
        height: Math.round(meta.baseHeight * scale)
      };
    }

    function lockPage() {
      document.documentElement.classList.add('mm-builder-open');
      document.body.classList.add('mm-builder-open');
    }

    function unlockPage() {
      document.documentElement.classList.remove('mm-builder-open');
      document.body.classList.remove('mm-builder-open');
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    }

    function openModal() {
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      modal.style.display = 'block';
      modal.style.visibility = 'visible';
      modal.style.pointerEvents = 'auto';
      modal.classList.add('show');
      lockPage();
      renderAll();
    }

    function closeModal() {
      resetSleeveZoom();
      modal.classList.remove('show');
      modal.style.display = 'none';
      modal.style.visibility = 'hidden';
      modal.style.pointerEvents = 'none';
      unlockPage();
    }

    function buildTopHost() {
      const topbar = modal.querySelector('.mm-builder-topbar');
      if (!topbar) return null;
      topbar.classList.add('mm-builder-topbar-phase1');

      const title = topbar.querySelector('.mm-builder-title');
      if (title && !topbar.querySelector('.mm-builder-brand')) {
        const brand = document.createElement('div');
        brand.className = 'mm-builder-brand';
        topbar.insertBefore(brand, saveBtn);
        brand.innerHTML = '<div class="mm-builder-brand-word">Mormor&rsquo;s</div>';
        title.textContent = 'Custom Shirt Builder';
        title.classList.add('mm-builder-brand-tag');
        brand.appendChild(title);
      }

      if (!document.getElementById('mm-modal-saved-counter')) {
        const counter = document.createElement('div');
        counter.id = 'mm-modal-saved-counter';
        counter.className = 'mm-modal-saved-counter';
        counter.textContent = 'Saved designs: 0';
        topbar.insertBefore(counter, saveBtn);
      }

      let progress = document.getElementById('mm-builder-progress');
      if (!progress) {
        progress = document.createElement('nav');
        progress.id = 'mm-builder-progress';
        progress.className = 'mm-builder-progress';
        progress.setAttribute('aria-label', 'Builder progress');
        topbar.insertAdjacentElement('afterend', progress);
      }
      topbar.appendChild(saveBtn);
      if (closeBtn) topbar.appendChild(closeBtn);
      return progress;
    }

    function buildLayoutUI() {
      layoutUIRoot.innerHTML = `
        <div class="mm-functional-layout">
          <div id="mm-step-one-panel" class="mm-step-one-panel"></div>

          <div id="layout-main-bar" class="mm-main-layout-bar">
            <button type="button" class="layout-tab" data-tab="front">Front</button>
            <button type="button" class="layout-tab" data-tab="back">Back</button>
            <button type="button" class="layout-tab" data-tab="front-back">Front + Back</button>
            <button type="button" class="layout-tab" data-tab="sleeves">Add Sleeves</button>
            <button type="button" id="setup-back-btn" class="mm-setup-back-btn" aria-label="Back to color and size">Back</button>
          </div>

          <div id="layout-sub-bar" class="mm-layout-sub-bar"></div>
          <div id="mm-later-step-panel" class="mm-later-step-panel"></div>
        </div>
      `;

      buildTopHost();
    }

    function buildPreviewRail() {
      const area = modal.querySelector('.mm-builder-preview-area');
      const wrap = area?.querySelector('.mm-preview-wrap');
      if (!area || !wrap) return;
      let rail = document.getElementById('mm-preview-view-rail');
      if (!rail) {
        rail = document.createElement('div');
        rail.id = 'mm-preview-view-rail';
        rail.innerHTML = `
          <button type="button" data-preview-view="front"><span>Front</span></button>
          <button type="button" data-preview-view="back"><span>Back</span></button>
          <button type="button" data-preview-view="rightSleeve"><span>Right Sleeve</span></button>
          <button type="button" data-preview-view="leftSleeve"><span>Left Sleeve</span></button>
        `;
        wrap.insertAdjacentElement('beforebegin', rail);
      }
      let zoomButton = document.getElementById('mm-sleeve-zoom-toggle');
      if (!zoomButton) {
        zoomButton = document.createElement('button');
        zoomButton.type = 'button';
        zoomButton.id = 'mm-sleeve-zoom-toggle';
        zoomButton.className = 'mm-sleeve-zoom-toggle';
        zoomButton.setAttribute('data-sleeve-zoom', '');
        zoomButton.hidden = true;
        zoomButton.textContent = 'Zoom';
        rail.insertAdjacentElement('afterend', zoomButton);
      }
    }

    function buildInlineToolbar() {
      const previewArea = modal.querySelector('.mm-builder-preview-area');
      if (!previewArea) return;
      let toolbar = document.getElementById('mm-inline-toolbar');
      if (!toolbar) {
        toolbar = document.createElement('div');
        toolbar.id = 'mm-inline-toolbar';
        toolbar.className = 'mm-inline-toolbar';
        toolbar.setAttribute('aria-live', 'polite');
        previewArea.appendChild(toolbar);
      }
    }

    function ensureSleeveImageWraps() {
      ['leftSleeve', 'rightSleeve'].forEach(function (view) {
        const preview = previews[view];
        const image = preview?.image;
        if (!image || image.parentElement?.classList.contains('mm-sleeve-image-wrap')) return;
        const wrap = document.createElement('div');
        wrap.className = `mm-sleeve-image-wrap mm-sleeve-image-wrap-${view}`;
        image.parentElement.insertBefore(wrap, image);
        wrap.appendChild(image);
      });
    }

    function canEnterStep(step) {
      if (step <= 1) return true;
      if (step === 2) return Boolean(builder.color && builder.size);
      if (step === 3) return Boolean(builder.color && builder.size && activeSlots().length);
      return false;
    }

    function setBuilderStep(step) {
      const next = Number(step) || 1;
      if (!canEnterStep(next)) return;
      builder.step = clamp(next, 1, 3);
      renderAll();
    }

    function renderProgress() {
      const progress = document.getElementById('mm-builder-progress');
      if (!progress) return;
      progress.innerHTML = BUILDER_STEPS.map(function (step, index) {
        const stepNumber = index + 1;
        const active = builder.step === stepNumber;
        const complete = stepNumber < builder.step;
        const disabled = !canEnterStep(stepNumber);
        const classes = [
          'mm-progress-step',
          active ? 'active' : '',
          complete ? 'done' : '',
          disabled ? 'disabled' : ''
        ].filter(Boolean).join(' ');
        return `
          <button type="button" class="${classes}" data-builder-step="${stepNumber}"${disabled ? ' disabled' : ''}>
            <span class="mm-progress-num">${complete ? '✓' : stepNumber}</span>
            <span class="mm-progress-copy"><strong>${esc(step[0])}</strong><small>${esc(step[1])}</small></span>
          </button>
        `;
      }).join('');
    }

    function updateSavedCounterDisplay() {
      const modalCounter = document.getElementById('mm-modal-saved-counter');
      if (modalCounter) modalCounter.textContent = `Saved designs: ${savedItems.length}`;
    }

    function renderStepOnePanel() {
      const panel = document.getElementById('mm-step-one-panel');
      if (!panel) return;
      const colorOptions = SHIRT_COLOR_OPTIONS.map(function (entry) {
        const value = entry[0];
        const label = entry[1];
        return `<option value="${esc(value)}"${builder.color === value ? ' selected' : ''}>${esc(label)}</option>`;
      }).join('');
      const sizeOptions = SHIRT_SIZE_OPTIONS.map(function (size) {
        return `<option value="${esc(size)}"${builder.size === size ? ' selected' : ''}>${esc(size)}</option>`;
      }).join('');
      const selectedColor = SHIRT_COLOR_OPTIONS.find(function (entry) { return entry[0] === builder.color; });
      const ready = Boolean(builder.color && builder.size);

      panel.innerHTML = `
        <div class="mm-step-panel-heading">
          <div class="mm-step-eyebrow">Step 1</div>
          <h3>Choose color &amp; size</h3>
        </div>
        <div class="mm-step-select-row">
          <label class="mm-step-select-field">
            <span>Shirt Color</span>
            <span class="mm-select-shell">
              <span class="mm-selected-color-dot" style="--shirt-swatch:${esc(selectedColor ? selectedColor[2] : '#ffffff')}"></span>
              <select id="shirt-color-picker" data-shirt-color-select aria-label="Select shirt color">
                <option value="">Select Color</option>
                ${colorOptions}
              </select>
            </span>
          </label>
          <label class="mm-step-select-field">
            <span>Shirt Size</span>
            <span class="mm-select-shell">
              <select id="shirt-size-picker" data-shirt-size-select aria-label="Select shirt size">
                <option value="">Select Size</option>
                ${sizeOptions}
              </select>
            </span>
          </label>
        </div>
        <button type="button" class="mm-builder-next" data-builder-next="2"${ready ? '' : ' disabled'}>Continue</button>
      `;
    }

    function renderSetupAndLayout() {
      const stepOne = document.getElementById('mm-step-one-panel');
      const main = document.getElementById('layout-main-bar');
      const sub = document.getElementById('layout-sub-bar');
      const later = document.getElementById('mm-later-step-panel');
      if (!stepOne || !main || !sub || !later) return;

      const ready = Boolean(builder.color && builder.size);
      if (!ready && builder.step > 1) builder.step = 1;
      if (builder.step > 3) builder.step = 3;
      modal.dataset.builderStep = String(builder.step);

      renderStepOnePanel();
      renderProgress();
      updateSavedCounterDisplay();

      const mainGroup = currentMainLayoutGroup();
      const summaryLabels = areaSummaryLabels();
      stepOne.classList.toggle('is-visible', builder.step === 1);
      main.classList.toggle('is-visible', builder.step === 2);
      sub.classList.toggle('is-visible', builder.step === 2 && Boolean(mainGroup));
      stepOne.style.display = builder.step === 1 ? 'block' : 'none';
      main.style.display = builder.step === 2 ? 'grid' : 'none';
      sub.style.display = builder.step === 2 && mainGroup ? 'grid' : 'none';
      later.style.display = builder.step === 2 ? 'block' : 'none';

      main.querySelectorAll('[data-tab]').forEach(function (button) {
        const tab = button.getAttribute('data-tab');
        button.classList.toggle('active', tab !== 'sleeves' && mainGroup === tab);
        button.classList.toggle('has-selection', tab === 'sleeves' && builder.sleeves.length);
      });

      if (builder.step === 2 && ready && mainGroup) {
        const options = LAYOUT_GROUPS[mainGroup] || [];
        sub.innerHTML = options.map(function (entry) {
          const value = entry[0];
          const label = entry[1];
          const active = builder.baseLayout === value;
          return `<button type="button" class="layout-pill${active ? ' active' : ''}" data-layout="${esc(value)}">${esc(label)}</button>`;
        }).join('');
      } else {
        sub.innerHTML = '';
      }

      if (builder.step === 2 && ready) {
        later.innerHTML = `
          <div class="mm-area-panel" id="mm-sleeve-area-panel">
            <div class="mm-area-panel-heading">
              <div class="mm-area-panel-title">Selected Areas</div>
              ${summaryLabels.length ? `<div class="mm-area-summary">${summaryLabels.map(function (label) { return `<span class="mm-area-summary-chip">${esc(label)}</span>`; }).join('')}</div>` : '<div class="mm-area-panel-note">Choose a front/back layout, sleeves, or sleeve-only.</div>'}
            </div>
            <div class="mm-area-panel-section">
              <div class="mm-area-panel-subtitle">Front / Back</div>
              <div class="mm-area-action-row">
                <button type="button" class="mm-area-toggle${!builder.baseLayout ? ' is-active' : ''}" data-clear-base-layout>Sleeve Only</button>
              </div>
            </div>
            <div class="mm-area-panel-section">
              <div class="mm-area-panel-subtitle">Add Sleeves</div>
              <div class="mm-area-action-row">
                <button type="button" class="mm-area-toggle${builder.sleeves.includes('sleeve_left') ? ' is-active' : ''}" data-toggle-sleeve="sleeve_left">Left Sleeve</button>
                <button type="button" class="mm-area-toggle${builder.sleeves.includes('sleeve_right') ? ' is-active' : ''}" data-toggle-sleeve="sleeve_right">Right Sleeve</button>
              </div>
            </div>
          </div>
        `;
      } else {
        later.innerHTML = '';
      }
    }

    function updateMockups() {
      const currentColor = builder.color || 'white';
      if (lastMockupColor && lastMockupColor !== currentColor) resetSleeveZoom();
      lastMockupColor = currentColor;
      const set = SHIRT_MOCKUPS[builder.color || 'white'] || SHIRT_MOCKUPS.white;
      Object.keys(previews).forEach(function (view) {
        if (previews[view].image && set[view]) previews[view].image.src = set[view];
      });
    }

    function clearTarget(target) {
      if (!target) return;
      target.innerHTML = '';
      target.className = target.className.replace(/\s*mm-zone-active|\s*mm-zone-selected/g, '');
      target.style.display = 'none';
      target.style.removeProperty('border');
      target.style.removeProperty('background');
    }

    function isVerticalSlot(slotKey) {
      return slotKey === 'front_center' || slotKey === 'back_center';
    }

    function clampOffset(slotKey, next) {
      const zone = PRINT_ZONES[slotKey];
      if (!zone || !isVerticalSlot(slotKey)) return 0;
      const absolute = zone.y + Number(next || 0);
      return clamp(absolute, zone.dragMinY, zone.dragMaxY) - zone.y;
    }

    function makeTextContent(state) {
      const shadows = state.outlineEnabled
        ? `-1px -1px 0 ${state.outlineColor},1px -1px 0 ${state.outlineColor},-1px 1px 0 ${state.outlineColor},1px 1px 0 ${state.outlineColor}`
        : 'none';
      return `<div class="mm-preview-text" style="font-family:${esc(state.font)};color:${esc(state.color)};text-shadow:${shadows};">${esc(state.text)}</div>`;
    }

    function makeImageContent(state) {
      return `<img class="mm-preview-art" src="${esc(state.image)}" alt="Uploaded artwork preview">`;
    }

    function makeInlineObjectContent(object) {
      if (object.type === 'logo') {
        return `<img class="mm-canvas-image" src="${esc(object.image || '')}" alt="Uploaded artwork">`;
      }
      const shadows = object.outlineEnabled
        ? `-1px -1px 0 ${object.outlineColor},1px -1px 0 ${object.outlineColor},-1px 1px 0 ${object.outlineColor},1px 1px 0 ${object.outlineColor}`
        : 'none';
      return `<div class="mm-canvas-text" style="font-family:${esc(object.font)};color:${esc(object.color)};text-shadow:${shadows};">${esc(object.text || '')}</div>`;
    }

    function renderPreviewZones() {
      Object.values(previewTargets).forEach(clearTarget);
      const current = activeSlots();

      current.forEach(function (slotKey) {
        const target = previewTargets[slotKey];
        const zone = PRINT_ZONES[slotKey];
        const state = normalizeSlotState(slotKey, builder.slots[slotKey] || defaultSlotState(slotKey));
        if (!target || !zone) return;

        target.style.left = zone.x + '%';
        target.style.top = zone.y + '%';
        target.style.width = zone.w + '%';
        target.style.height = zone.h + '%';
        target.style.display = 'block';
        target.classList.add('mm-zone-active');
        target.classList.toggle('mm-zone-selected', slotKey === builder.activeSlot);
        target.dataset.slotKey = slotKey;

        const objectsMarkup = state.objects.map(function (object) {
          const dims = objectDimensions(slotKey, object);
          const selected = slotKey === builder.activeSlot && object.id === state.selectedId;
          const resizeHandle = FIXED_SIZE_SLOTS.has(slotKey) ? '' : '<button type="button" class="mm-object-handle mm-handle-resize" data-object-resize aria-label="Resize">↘</button>';
          return `
            <div class="mm-canvas-item ${esc(object.type)}${selected ? ' selected' : ''}" data-object-id="${esc(object.id)}" data-object-slot="${esc(slotKey)}" style="left:${Number(object.x || 50)}%;top:${Number(object.y || 50)}%;width:${dims.width}px;height:${dims.height}px;transform:translate(-50%,-50%) rotate(${snapRotation(object.rotation || 0)}deg);">
              ${makeInlineObjectContent(object)}
              <button type="button" class="mm-object-handle mm-handle-delete" data-object-delete aria-label="Delete">×</button>
              <button type="button" class="mm-object-handle mm-handle-rotate" data-object-rotate aria-label="Rotate">↻</button>
              <button type="button" class="mm-object-handle mm-handle-duplicate" data-object-duplicate aria-label="Duplicate">▣</button>
              ${resizeHandle}
            </div>
          `;
        }).join('');

        target.innerHTML = `
          <div class="mm-print-zone-label">${esc(SLOT_META[slotKey].label)}</div>
          <div class="mm-inline-canvas" data-canvas-slot="${esc(slotKey)}">${objectsMarkup}</div>
        `;
      });
    }

    function isSleeveView(view) {
      return view === 'leftSleeve' || view === 'rightSleeve';
    }

    function selectedPreviewViews() {
      const views = activeSlots().map(function (slotKey) {
        return PRINT_ZONES[slotKey]?.view;
      }).filter(Boolean);
      if (!views.length && builder.activeView) views.push(builder.activeView);
      return Array.from(new Set(views));
    }

    function slotForPreviewView(view) {
      const current = activeSlots();
      if (builder.activeSlot && PRINT_ZONES[builder.activeSlot]?.view === view) return builder.activeSlot;
      return current.find(function (slotKey) {
        return PRINT_ZONES[slotKey]?.view === view;
      }) || '';
    }

    function viewHasSelectedSlots(view) {
      return activeSlots().some(function (slotKey) {
        return PRINT_ZONES[slotKey]?.view === view;
      });
    }

    function previewWorkspaceWidth() {
      const wrap = modal.querySelector('.mm-preview-wrap');
      return wrap?.getBoundingClientRect().width || 0;
    }

    function canUseDualFrontBackPreview() {
      return builder.step === 3
        && viewHasSelectedSlots('front')
        && viewHasSelectedSlots('back')
        && (builder.activeView === 'front' || builder.activeView === 'back')
        && previewWorkspaceWidth() >= 760;
    }

    function updatePreviewRail(view) {
      const allowedViews = selectedPreviewViews();
      document.querySelectorAll('[data-preview-view]').forEach(function (button) {
        const buttonView = button.getAttribute('data-preview-view');
        const visible = allowedViews.includes(buttonView);
        button.hidden = !visible;
        button.style.display = visible ? '' : 'none';
        button.classList.toggle('active', buttonView === view);
      });
    }

    function updateSleeveZoomButton() {
      const zoomButton = document.getElementById('mm-sleeve-zoom-toggle');
      if (!zoomButton) return;
      const allowedViews = selectedPreviewViews();
      const canZoom = isSleeveView(builder.activeView) && allowedViews.includes(builder.activeView);
      zoomButton.hidden = !canZoom;
      zoomButton.style.display = canZoom ? '' : 'none';
      zoomButton.classList.toggle('is-active', sleeveZoomView === builder.activeView && canZoom);
      zoomButton.textContent = sleeveZoomView === builder.activeView && canZoom ? 'Reset' : 'Zoom';
      zoomButton.setAttribute('aria-pressed', sleeveZoomView === builder.activeView && canZoom ? 'true' : 'false');
    }

    function resetSleeveZoom() {
      sleeveZoomView = '';
      modal.classList.remove('mm-sleeve-zoom-active');
      if (previews.leftSleeve.card) previews.leftSleeve.card.classList.remove('mm-sleeve-zoomed');
      if (previews.rightSleeve.card) previews.rightSleeve.card.classList.remove('mm-sleeve-zoomed');
      updateSleeveZoomButton();
    }

    function setSleeveZoom(view, enabled) {
      if (!isSleeveView(view) || !selectedPreviewViews().includes(view)) {
        resetSleeveZoom();
        return;
      }
      sleeveZoomView = enabled ? view : '';
      modal.classList.toggle('mm-sleeve-zoom-active', Boolean(sleeveZoomView));
      if (previews.leftSleeve.card) previews.leftSleeve.card.classList.toggle('mm-sleeve-zoomed', sleeveZoomView === 'leftSleeve');
      if (previews.rightSleeve.card) previews.rightSleeve.card.classList.toggle('mm-sleeve-zoomed', sleeveZoomView === 'rightSleeve');
      updateSleeveZoomButton();
    }

    function setPreviewView(view) {
      if (!previews[view]) return;
      const allowedViews = selectedPreviewViews();
      const nextView = allowedViews.includes(view) ? view : (allowedViews[0] || 'front');
      if (builder.activeView !== nextView) resetSleeveZoom();
      builder.activeView = nextView;
      const slotKey = slotForPreviewView(nextView);
      if (slotKey) builder.activeSlot = slotKey;
      const frontCard = previews.front.card;
      const backCard = previews.back.card;
      const leftCard = previews.leftSleeve.card;
      const rightCard = previews.rightSleeve.card;
      const previewGrid = modal.querySelector('.mm-preview-grid');

      [frontCard, backCard, leftCard, rightCard].forEach(function (card) {
        if (card) {
          card.style.display = 'none';
          card.classList.remove('mm-active-preview-card');
        }
      });
      if (sleeveRow) sleeveRow.style.display = 'none';
      if (previewGrid) previewGrid.classList.toggle('mm-dual-preview-grid', canUseDualFrontBackPreview());
      modal.classList.toggle('mm-dual-preview-active', canUseDualFrontBackPreview());

      if (canUseDualFrontBackPreview()) {
        if (frontCard) frontCard.style.display = 'block';
        if (backCard) backCard.style.display = 'block';
        if (previews[nextView].card) previews[nextView].card.classList.add('mm-active-preview-card');
      } else {
        if (nextView === 'front' && frontCard) frontCard.style.display = 'block';
        if (nextView === 'back' && backCard) backCard.style.display = 'block';
        if (nextView === 'leftSleeve') {
          if (sleeveRow) sleeveRow.style.display = 'flex';
          if (leftCard) leftCard.style.display = 'block';
        }
        if (nextView === 'rightSleeve') {
          if (sleeveRow) sleeveRow.style.display = 'flex';
          if (rightCard) rightCard.style.display = 'block';
        }
        if (previews[nextView].card) previews[nextView].card.classList.add('mm-active-preview-card');
      }

      updatePreviewRail(nextView);
      if (!isSleeveView(nextView)) resetSleeveZoom();
      else updateSleeveZoomButton();
    }

    function renderInlineToolbar() {
      const toolbar = document.getElementById('mm-inline-toolbar');
      if (!toolbar) return;
      if (builder.step !== 3 || !builder.activeSlot) {
        toolbar.innerHTML = '';
        toolbar.style.display = 'none';
        return;
      }
      toolbar.style.display = 'block';
      const current = activeSlots();
      const state = normalizeSlotState(builder.activeSlot, builder.slots[builder.activeSlot]);
      const object = selectedObject(builder.activeSlot);
      const slotTabs = current.map(function (slotKey) {
        return `<button type="button" class="mm-inline-chip${slotKey === builder.activeSlot ? ' active' : ''}" data-slot-chip="${esc(slotKey)}">${esc(SLOT_META[slotKey].label)}</button>`;
      }).join('');
      const fontOptions = FONT_OPTIONS.map(function (entry) {
        return `<option value="${esc(entry[0])}"${object && object.font === entry[0] ? ' selected' : ''}>${esc(entry[1])}</option>`;
      }).join('');
      const colorButtons = COLORS.map(function (color) {
        return `<button type="button" class="mm-inline-color${object && object.color === color ? ' active' : ''}" data-inline-color="${esc(color)}" style="--inline-color:${esc(color)}" aria-label="${esc(color)}"></button>`;
      }).join('');
      const outlineButtons = OUTLINE_COLORS.map(function (color) {
        return `<button type="button" class="mm-inline-color${object && object.outlineColor === color ? ' active' : ''}" data-inline-outline-color="${esc(color)}" style="--inline-color:${esc(color)}" aria-label="${esc(color)}"></button>`;
      }).join('');

      let controls = '<div class="mm-inline-empty">Add text or upload artwork to this print area.</div>';
      if (object && object.type === 'text') {
        controls = `
          <input class="mm-inline-control mm-inline-text-input" type="text" maxlength="40" data-inline-text value="${esc(object.text || '')}" aria-label="Edit text">
          <select class="mm-inline-control" data-inline-font aria-label="Font">${fontOptions}</select>
          <div class="mm-inline-color-row">${colorButtons}</div>
          <button type="button" class="mm-inline-outline${object.outlineEnabled ? ' active' : ''}" data-inline-outline>Outline ${object.outlineEnabled ? 'On' : 'Off'}</button>
          <div class="mm-inline-outline-row${object.outlineEnabled ? ' is-visible' : ''}">${outlineButtons}</div>
        `;
      }
      if (object && object.type === 'logo') {
        controls = `
          <label class="mm-inline-upload active">Replace image<input type="file" accept="image/png,image/jpeg,image/jpg,image/webp" data-inline-replace></label>
          <button type="button" class="mm-inline-tool" data-inline-center>Center</button>
          <button type="button" class="mm-inline-tool" data-inline-fit>Fit</button>
          <span class="mm-inline-file-name">${esc(object.fileName || 'Artwork')}</span>
        `;
      }

      toolbar.innerHTML = `
        <div class="mm-inline-toolbar-top">
          <div class="mm-inline-slot-tabs">${slotTabs}</div>
          <div class="mm-inline-help">Select and drag the design. Use the four corner controls to delete, rotate, duplicate, and resize.</div>
        </div>
        <div class="mm-inline-toolbar-main">
          <div class="mm-inline-add-group">
            <button type="button" class="mm-inline-tool" data-inline-add-text>＋ Text</button>
            <label class="mm-inline-upload">↑ Upload<input type="file" accept="image/png,image/jpeg,image/jpg,image/webp" data-inline-upload></label>
          </div>
          <div class="mm-inline-context-controls">${controls}</div>
        </div>
      `;
    }

    function renderSlotEditor() {
      const current = activeSlots();
      if (!current.length) {
        slotEditorRoot.innerHTML = '<div class="mm-empty-editor">Choose a print position to start.</div>';
        renderInlineToolbar();
        return;
      }
      ensureActiveSlotStates();
      slotEditorRoot.innerHTML = `
        <div class="mm-inline-side-summary">
          <strong>${esc(SLOT_META[builder.activeSlot].label)}</strong>
          <span>Edit directly on the preview. The controls appear in the bottom bar.</span>
        </div>
      `;
      renderInlineToolbar();
    }

    function updateSaveState() {
      const current = activeSlots();
      const ready = Boolean(builder.color && builder.size && current.length);
      const complete = ready && current.every(function (slotKey) {
        const state = normalizeSlotState(slotKey, builder.slots[slotKey] || defaultSlotState(slotKey));
        return state.objects.some(validDesignObject);
      });
      saveBtn.disabled = !complete;
      saveBtn.setAttribute('aria-disabled', complete ? 'false' : 'true');
    }

    function updatePrice() {
      if (priceEl) priceEl.textContent = `Total: $${BASE_PRICE.toFixed(2)}`;
    }

    function renderAll() {
      renderSetupAndLayout();
      updateMockups();
      ensureActiveSlotStates();
      setPreviewView(builder.activeView || 'front');
      renderSlotEditor();
      renderPreviewZones();
      updateSaveState();
      updatePrice();
      if (layoutSelect) layoutSelect.value = builder.baseLayout || (builder.sleeves.length ? 'sleeve-only' : '');
    }

    function setBaseLayout(layout) {
      builder.baseLayout = layout;
      const newSlots = BASE_LAYOUT_SLOTS[layout] || [];
      ensureActiveSlotStates();
      builder.activeSlot = newSlots[0] || builder.sleeves[0] || '';
      if (builder.activeSlot) builder.activeView = PRINT_ZONES[builder.activeSlot].view;
      if (activeSlots().length) builder.step = 3;
      renderAll();
    }

    function clearBaseLayout() {
      builder.baseLayout = '';
      ensureActiveSlotStates();
      builder.activeSlot = builder.sleeves[0] || '';
      if (builder.activeSlot) builder.activeView = PRINT_ZONES[builder.activeSlot].view;
      builder.step = activeSlots().length ? 3 : 2;
      renderAll();
    }

    function toggleSleeveSelection(slotKey) {
      if (!['sleeve_left', 'sleeve_right'].includes(slotKey)) return;
      const next = new Set(builder.sleeves);
      if (next.has(slotKey)) next.delete(slotKey);
      else next.add(slotKey);
      builder.sleeves = ['sleeve_left', 'sleeve_right'].filter(function (key) { return next.has(key); });
      ensureActiveSlotStates();
      if (builder.sleeves.includes(slotKey)) {
        builder.activeSlot = slotKey;
        builder.activeView = PRINT_ZONES[slotKey].view;
      }
      if (activeSlots().length) builder.step = 3;
      else builder.step = 2;
      renderAll();
    }

    function setSleeves(value) {
      if (value === 'sleeve-left') builder.sleeves = ['sleeve_left'];
      if (value === 'sleeve-right') builder.sleeves = ['sleeve_right'];
      if (value === 'sleeve-both') builder.sleeves = ['sleeve_left', 'sleeve_right'];
      if (value === 'sleeve-none') builder.sleeves = [];
      ensureActiveSlotStates();
      if (value !== 'sleeve-none') {
        builder.activeSlot = builder.sleeves[0] || builder.activeSlot;
        if (builder.activeSlot) builder.activeView = PRINT_ZONES[builder.activeSlot].view;
      }
      if (activeSlots().length) builder.step = 3;
      renderAll();
    }

    function resetBuilder() {
      builder = createEmptyBuilderState();
      drag = null;
      resetSleeveZoom();
      renderAll();
    }

    function scheduleResponsivePreviewUpdate() {
      if (!modal.classList.contains('show') || drag) return;
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () {
        resizeFrame = 0;
        setPreviewView(builder.activeView || 'front');
        renderSlotEditor();
        renderPreviewZones();
      });
    }

    function cloneSlotsForSave() {
      const copy = {};
      activeSlots().forEach(function (slotKey) {
        const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
        syncLegacyFields(slotKey);
        copy[slotKey] = {
          selectedId: state.selectedId,
          objects: state.objects.map(function (object) {
            return {
              id: object.id,
              type: object.type,
              text: object.text || '',
              image: object.image || '',
              file: object.file || null,
              fileName: object.fileName || '',
              font: object.font || 'Arial Black, Arial, sans-serif',
              color: object.color || '#000000',
              outlineEnabled: Boolean(object.outlineEnabled),
              outlineColor: object.outlineColor || '#ffffff',
              scale: Number(object.scale || 100),
              rotation: Number(object.rotation || 0),
              x: Number(object.x || 50),
              y: Number(object.y || 50)
            };
          })
        };
      });
      return copy;
    }

    function describeBaseLayout(layout) {
      const labels = {
        left: 'Left Chest', right: 'Right Chest', center: 'Center Front', 'left-right': 'Left + Right Chest',
        'back-center': 'Back Center', 'back-upper': 'Upper Back Small',
        'front-back-center': 'Front Center + Back Center', 'left-back-center': 'Left Chest + Back Center',
        'right-back-center': 'Right Chest + Back Center', 'front-back-upper': 'Front Center + Upper Back'
      };
      return labels[layout] || (layout ? layout : 'Sleeves Only');
    }

    function appendProperty(formData, key, value) {
      if (value == null || String(value).trim() === '') return;
      formData.append(`properties[${key}]`, String(value));
    }

    async function addSavedItemToCart(item, groupId) {
      const fd = new FormData();
      fd.append('id', String(VARIANT_ID));
      fd.append('quantity', '1');
      appendProperty(fd, 'Shirt Color', item.color);
      appendProperty(fd, 'Shirt Size', item.size);
      appendProperty(fd, 'Main Layout', describeBaseLayout(item.baseLayout));
      appendProperty(fd, 'Sleeves', item.sleeves.length ? item.sleeves.map(function (key) { return SLOT_META[key].label; }).join(' + ') : 'None');
      appendProperty(fd, '_group_id', groupId);

      Object.keys(item.slots).forEach(function (slotKey) {
        const slot = item.slots[slotKey] || {};
        const objects = Array.isArray(slot.objects) ? slot.objects : [];
        const label = SLOT_META[slotKey].label;
        const meta = SLOT_META[slotKey];
        objects.filter(validDesignObject).forEach(function (object, index) {
          const itemNumber = index + 1;
          const prefix = itemNumber === 1 ? label : `${label} Item ${itemNumber}`;
          const scale = Number(object.scale || 100);
          const dims = {
            width: Math.round(meta.baseWidth * (scale / 100)),
            height: Math.round(meta.baseHeight * (scale / 100))
          };
          appendProperty(fd, `${prefix} Type`, object.type === 'logo' ? 'Uploaded Artwork' : 'Text');
          appendProperty(fd, `${prefix} Scale`, `${scale}%`);
          appendProperty(fd, `${prefix} Width`, `${pxToInches(dims.width)}"`);
          appendProperty(fd, `${prefix} Height`, `${pxToInches(dims.height)}"`);
          appendProperty(fd, `${prefix} Rotation`, `${Number(object.rotation || 0)}°`);
          appendProperty(fd, `${prefix} X Position`, `${Number(object.x || 50).toFixed(1)}%`);
          appendProperty(fd, `${prefix} Y Position`, `${Number(object.y || 50).toFixed(1)}%`);
          if (object.type === 'text') {
            appendProperty(fd, `${prefix} Text`, String(object.text || '').trim());
            appendProperty(fd, `${prefix} Font`, object.font);
            appendProperty(fd, `${prefix} Text Color`, object.color);
            appendProperty(fd, `${prefix} Outline`, object.outlineEnabled ? 'Yes' : 'No');
            if (object.outlineEnabled) appendProperty(fd, `${prefix} Outline Color`, object.outlineColor);
          }
          if (object.type === 'logo' && object.file) {
            fd.append(`properties[${prefix} Artwork]`, object.file, object.file.name || `${prefix}-artwork`);
            appendProperty(fd, `${prefix} Artwork Name`, object.file.name || object.fileName || 'Uploaded artwork');
          }
        });
      });

      const response = await fetch('/cart/add', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error(await response.text());
    }

    function addTextObject(slotKey) {
      if (!slotKey) return;
      const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
      const object = createDesignObject('text', slotKey);
      state.objects.push(object);
      state.selectedId = object.id;
      renderPreviewZones();
      renderInlineToolbar();
      updateSaveState();
    }

    function addArtworkObject(slotKey, file, replaceObject) {
      if (!slotKey || !file) return;
      if (!/^image\/(png|jpe?g|webp)$/i.test(file.type || '')) {
        alert('Please upload a PNG, JPG, JPEG, or WEBP image.');
        return;
      }
      const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
      const object = replaceObject || createDesignObject('logo', slotKey);
      object.type = 'logo';
      object.file = file;
      object.fileName = file.name || 'Artwork';
      const reader = new FileReader();
      reader.onload = function (loadEvent) {
        object.image = loadEvent.target.result;
        if (!replaceObject) {
          state.objects.push(object);
          state.selectedId = object.id;
        }
        fitObjectToSlot(slotKey, object);
        renderPreviewZones();
        renderInlineToolbar();
        updateSaveState();
      };
      reader.readAsDataURL(file);
    }

    function deleteSelectedObject(slotKey) {
      const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
      state.objects = state.objects.filter(function (object) { return object.id !== state.selectedId; });
      state.selectedId = state.objects[0]?.id || '';
      renderPreviewZones();
      renderInlineToolbar();
      updateSaveState();
    }

    function duplicateSelectedObject(slotKey) {
      const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
      const object = selectedObject(slotKey);
      if (!object) return;
      const copy = Object.assign({}, object, {
        id: nextObjectId(),
        x: clamp(Number(object.x || 50) + 8, 8, 92),
        y: clamp(Number(object.y || 50) + 8, 8, 92)
      });
      state.objects.push(copy);
      state.selectedId = copy.id;
      clampObjectPosition(slotKey, copy);
      renderPreviewZones();
      renderInlineToolbar();
      updateSaveState();
    }

    function beginPointerSession(event, mode, slotKey, objectId, item) {
      const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
      const object = state.objects.find(function (entry) { return entry.id === objectId; });
      const target = previewTargets[slotKey];
      if (!object || !target || !item) return;
      state.selectedId = objectId;
      const targetRect = target.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const centerX = itemRect.left + itemRect.width / 2;
      const centerY = itemRect.top + itemRect.height / 2;
      pointerSession = {
        pointerId: event.pointerId,
        mode: mode,
        slotKey: slotKey,
        objectId: objectId,
        item: item,
        target: target,
        targetRect: targetRect,
        startX: event.clientX,
        startY: event.clientY,
        startObjectX: Number(object.x || 50),
        startObjectY: Number(object.y || 50),
        startScale: Number(object.scale || 100),
        startRotation: Number(object.rotation || 0),
        centerX: centerX,
        centerY: centerY,
        startDistance: Math.max(1, Math.hypot(event.clientX - centerX, event.clientY - centerY)),
        startAngle: Math.atan2(event.clientY - centerY, event.clientX - centerX)
      };
      item.setPointerCapture?.(event.pointerId);
      event.preventDefault();
      event.stopPropagation();
      renderInlineToolbar();
    }

    function updatePointerSession(event) {
      if (!pointerSession || event.pointerId !== pointerSession.pointerId) return;
      const state = normalizeSlotState(pointerSession.slotKey, builder.slots[pointerSession.slotKey]);
      const object = state.objects.find(function (entry) { return entry.id === pointerSession.objectId; });
      if (!object) return;
      if (pointerSession.mode === 'drag') {
        object.x = pointerSession.startObjectX + ((event.clientX - pointerSession.startX) / pointerSession.targetRect.width) * 100;
        object.y = pointerSession.startObjectY + ((event.clientY - pointerSession.startY) / pointerSession.targetRect.height) * 100;
      }
      if (pointerSession.mode === 'resize' && !FIXED_SIZE_SLOTS.has(pointerSession.slotKey)) {
        const distance = Math.max(1, Math.hypot(event.clientX - pointerSession.centerX, event.clientY - pointerSession.centerY));
        const zone = PRINT_ZONES[pointerSession.slotKey];
        object.scale = clamp(pointerSession.startScale * distance / pointerSession.startDistance, zone.scaleMin, zone.scaleMax);
      }
      if (pointerSession.mode === 'rotate') {
        const angle = Math.atan2(event.clientY - pointerSession.centerY, event.clientX - pointerSession.centerX);
        object.rotation = snapRotation(pointerSession.startRotation + ((angle - pointerSession.startAngle) * 180 / Math.PI));
      }
      clampObjectPosition(pointerSession.slotKey, object, pointerSession.target);
      const dims = objectDimensions(pointerSession.slotKey, object);
      pointerSession.item.style.left = object.x + '%';
      pointerSession.item.style.top = object.y + '%';
      pointerSession.item.style.width = dims.width + 'px';
      pointerSession.item.style.height = dims.height + 'px';
      pointerSession.item.style.transform = `translate(-50%,-50%) rotate(${snapRotation(object.rotation)}deg)`;
      event.preventDefault();
    }

    function endPointerSession(event) {
      if (!pointerSession || (event.pointerId != null && event.pointerId !== pointerSession.pointerId)) return;
      pointerSession.item?.releasePointerCapture?.(pointerSession.pointerId);
      pointerSession = null;
      renderPreviewZones();
      renderInlineToolbar();
      updateSaveState();
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });

    closeBtn?.addEventListener('click', function (event) {
      event.preventDefault();
      closeModal();
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('change', function (event) {
      const colorSelect = event.target.closest('[data-shirt-color-select]');
      if (colorSelect && modal.contains(colorSelect)) {
        builder.color = colorSelect.value || '';
        renderAll();
        return;
      }

      const sizeSelect = event.target.closest('[data-shirt-size-select]');
      if (sizeSelect && modal.contains(sizeSelect)) {
        builder.size = sizeSelect.value || '';
        renderAll();
        return;
      }

      const colorPicker = event.target.closest('#shirt-color-picker');
      if (colorPicker) {
        builder.color = colorPicker.value || '';
        renderAll();
        return;
      }
      const sizePicker = event.target.closest('#shirt-size-picker');
      if (sizePicker) {
        builder.size = sizePicker.value || '';
        renderAll();
      }
    });

    document.addEventListener('click', function (event) {
      const stepButton = event.target.closest('.mm-progress-step[data-builder-step]');
      if (stepButton && modal.contains(stepButton)) {
        setBuilderStep(stepButton.getAttribute('data-builder-step'));
        return;
      }

      const nextButton = event.target.closest('[data-builder-next]');
      if (nextButton && modal.contains(nextButton)) {
        setBuilderStep(nextButton.getAttribute('data-builder-next'));
        return;
      }

      const shirtColor = event.target.closest('[data-shirt-color]');
      if (shirtColor && modal.contains(shirtColor)) {
        builder.color = shirtColor.getAttribute('data-shirt-color') || '';
        renderAll();
        return;
      }

      const shirtSize = event.target.closest('[data-shirt-size]');
      if (shirtSize && modal.contains(shirtSize)) {
        builder.size = shirtSize.getAttribute('data-shirt-size') || '';
        renderAll();
        return;
      }

      const tab = event.target.closest('[data-tab]');
      if (tab && modal.contains(tab)) {
        if (!builder.color || !builder.size) return;
        const nextTab = tab.getAttribute('data-tab') || '';
        if (nextTab !== 'sleeves') builder.openGroup = nextTab;
        renderAll();
        return;
      }

      const setupBack = event.target.closest('#setup-back-btn');
      if (setupBack) {
        builder.step = 1;
        renderAll();
        return;
      }

      const pill = event.target.closest('[data-layout]');
      if (pill && modal.contains(pill)) {
        const value = pill.getAttribute('data-layout');
        if (builder.openGroup === 'sleeves') setSleeves(value);
        else setBaseLayout(value);
        return;
      }

      const clearBaseButton = event.target.closest('[data-clear-base-layout]');
      if (clearBaseButton && modal.contains(clearBaseButton)) {
        clearBaseLayout();
        return;
      }

      const toggleSleeveButton = event.target.closest('[data-toggle-sleeve]');
      if (toggleSleeveButton && modal.contains(toggleSleeveButton)) {
        toggleSleeveSelection(toggleSleeveButton.getAttribute('data-toggle-sleeve'));
        return;
      }

      const slotChip = event.target.closest('[data-slot-chip]');
      if (slotChip && modal.contains(slotChip)) {
        builder.activeSlot = slotChip.getAttribute('data-slot-chip');
        builder.activeView = PRINT_ZONES[builder.activeSlot].view;
        renderAll();
        return;
      }

      const viewButton = event.target.closest('[data-preview-view]');
      if (viewButton && modal.contains(viewButton)) {
        setPreviewView(viewButton.getAttribute('data-preview-view'));
        renderSlotEditor();
        renderPreviewZones();
        updateSaveState();
        return;
      }

      const zoomButton = event.target.closest('[data-sleeve-zoom]');
      if (zoomButton && modal.contains(zoomButton)) {
        setSleeveZoom(builder.activeView, sleeveZoomView !== builder.activeView);
        return;
      }

      const previewCard = event.target.closest('.mm-preview-card');
      if (previewCard && modal.contains(previewCard) && !event.target.closest('.mm-canvas-item, .mm-object-handle, [data-drag-slot], [data-slot-chip], [data-layout], [data-tab]')) {
        const viewEntry = Object.keys(previews).find(function (key) {
          return previews[key].card === previewCard;
        });
        if (viewEntry && selectedPreviewViews().includes(viewEntry)) {
          setPreviewView(viewEntry);
          if (isSleeveView(viewEntry) && window.matchMedia('(hover: none), (pointer: coarse)').matches) {
            setSleeveZoom(viewEntry, sleeveZoomView !== viewEntry);
          }
          renderSlotEditor();
          renderPreviewZones();
          updateSaveState();
        }
        return;
      }

      const canvasItem = event.target.closest('.mm-canvas-item');
      if (canvasItem && modal.contains(canvasItem) && !event.target.closest('.mm-object-handle')) {
        const slotKey = canvasItem.getAttribute('data-object-slot');
        const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
        builder.activeSlot = slotKey;
        builder.activeView = PRINT_ZONES[slotKey].view;
        state.selectedId = canvasItem.getAttribute('data-object-id');
        renderPreviewZones();
        renderInlineToolbar();
        return;
      }

      const deleteObject = event.target.closest('[data-object-delete]');
      if (deleteObject && modal.contains(deleteObject)) {
        const item = deleteObject.closest('.mm-canvas-item');
        const slotKey = item?.getAttribute('data-object-slot');
        if (slotKey) deleteSelectedObject(slotKey);
        return;
      }

      const duplicateObject = event.target.closest('[data-object-duplicate]');
      if (duplicateObject && modal.contains(duplicateObject)) {
        const item = duplicateObject.closest('.mm-canvas-item');
        const slotKey = item?.getAttribute('data-object-slot');
        if (slotKey) duplicateSelectedObject(slotKey);
        return;
      }

      const addText = event.target.closest('[data-inline-add-text]');
      if (addText && modal.contains(addText)) {
        addTextObject(builder.activeSlot);
        return;
      }

      const inlineColor = event.target.closest('[data-inline-color]');
      if (inlineColor && modal.contains(inlineColor)) {
        const object = selectedObject(builder.activeSlot);
        if (object && object.type === 'text') object.color = inlineColor.getAttribute('data-inline-color');
        renderPreviewZones();
        renderInlineToolbar();
        return;
      }

      const inlineOutlineColor = event.target.closest('[data-inline-outline-color]');
      if (inlineOutlineColor && modal.contains(inlineOutlineColor)) {
        const object = selectedObject(builder.activeSlot);
        if (object && object.type === 'text') object.outlineColor = inlineOutlineColor.getAttribute('data-inline-outline-color');
        renderPreviewZones();
        renderInlineToolbar();
        return;
      }

      const inlineOutline = event.target.closest('[data-inline-outline]');
      if (inlineOutline && modal.contains(inlineOutline)) {
        const object = selectedObject(builder.activeSlot);
        if (object && object.type === 'text') object.outlineEnabled = !object.outlineEnabled;
        renderPreviewZones();
        renderInlineToolbar();
        return;
      }

      const inlineCenter = event.target.closest('[data-inline-center]');
      if (inlineCenter && modal.contains(inlineCenter)) {
        const object = selectedObject(builder.activeSlot);
        if (object) { object.x = 50; object.y = 50; object.rotation = 0; clampObjectPosition(builder.activeSlot, object); }
        renderPreviewZones();
        renderInlineToolbar();
        return;
      }

      const inlineFit = event.target.closest('[data-inline-fit]');
      if (inlineFit && modal.contains(inlineFit)) {
        const object = selectedObject(builder.activeSlot);
        fitObjectToSlot(builder.activeSlot, object);
        renderPreviewZones();
        renderInlineToolbar();
        return;
      }

      const typeButton = event.target.closest('[data-type]');
      if (typeButton && slotEditorRoot.contains(typeButton)) {
        const slotKey = builder.activeSlot;
        if (!slotKey) return;
        const state = builder.slots[slotKey] || defaultSlotState(slotKey);
        const nextType = typeButton.getAttribute('data-type');
        if (state.type !== nextType) {
          state.type = nextType;
          state.text = '';
          state.image = '';
          state.file = null;
          state.fileName = '';
        }
        builder.slots[slotKey] = state;
        renderAll();
        return;
      }

      const color = event.target.closest('[data-slot-color]');
      if (color && slotEditorRoot.contains(color)) {
        builder.slots[builder.activeSlot].color = color.getAttribute('data-slot-color');
        renderAll();
        return;
      }

      const outlineColor = event.target.closest('[data-outline-color]');
      if (outlineColor && slotEditorRoot.contains(outlineColor)) {
        builder.slots[builder.activeSlot].outlineColor = outlineColor.getAttribute('data-outline-color');
        renderAll();
        return;
      }

      const rotate = event.target.closest('[data-rotate]');
      if (rotate && slotEditorRoot.contains(rotate)) {
        const state = builder.slots[builder.activeSlot];
        state.rotation = clamp(snapRotation(state.rotation + Number(rotate.getAttribute('data-rotate'))), -180, 180);
        renderAll();
        return;
      }

      const rotateReset = event.target.closest('[data-rotate-reset]');
      if (rotateReset && slotEditorRoot.contains(rotateReset)) {
        builder.slots[builder.activeSlot].rotation = 0;
        renderAll();
      }
    });

    document.addEventListener('input', function (event) {
      if (!modal.contains(event.target)) return;
      const object = selectedObject(builder.activeSlot);
      if (!object) return;
      if (event.target.matches('[data-inline-text]')) {
        object.text = event.target.value || '';
        renderPreviewZones();
        updateSaveState();
      }
    });

    document.addEventListener('change', function (event) {
      if (!modal.contains(event.target)) return;
      const object = selectedObject(builder.activeSlot);
      if (event.target.matches('[data-inline-font]') && object && object.type === 'text') {
        object.font = event.target.value;
        renderPreviewZones();
        return;
      }
      if (event.target.matches('[data-inline-upload]')) {
        const file = event.target.files && event.target.files[0];
        addArtworkObject(builder.activeSlot, file, null);
        event.target.value = '';
        return;
      }
      if (event.target.matches('[data-inline-replace]') && object && object.type === 'logo') {
        const file = event.target.files && event.target.files[0];
        addArtworkObject(builder.activeSlot, file, object);
        event.target.value = '';
      }
    });

    slotEditorRoot.addEventListener('input', function (event) {
      const state = builder.slots[builder.activeSlot];
      if (!state) return;
      if (event.target.matches('[data-text-input]')) {
        state.text = event.target.value || '';
        renderPreviewZones();
        updateSaveState();
      }
      if (event.target.matches('[data-scale-input]')) {
        const zone = PRINT_ZONES[builder.activeSlot];
        state.scale = clamp(event.target.value, zone.scaleMin, zone.scaleMax);
        renderSlotEditor();
        renderPreviewZones();
        updateSaveState();
      }
    });

    slotEditorRoot.addEventListener('change', function (event) {
      const state = builder.slots[builder.activeSlot];
      if (!state) return;

      if (event.target.matches('[data-font-select]')) {
        state.font = event.target.value;
        renderPreviewZones();
      }
      if (event.target.matches('[data-outline-toggle]')) {
        state.outlineEnabled = event.target.checked;
        renderAll();
      }
      if (event.target.matches('[data-file-input]')) {
        const file = event.target.files && event.target.files[0];
        if (!file) return;
        if (!/^image\/(png|jpe?g|webp)$/i.test(file.type || '')) {
          alert('Please upload a PNG, JPG, JPEG, or WEBP image.');
          return;
        }
        state.file = file;
        state.fileName = file.name;
        const reader = new FileReader();
        reader.onload = function (loadEvent) {
          state.image = loadEvent.target.result;
          renderAll();
        };
        reader.readAsDataURL(file);
      }
    });

    modal.addEventListener('pointerdown', function (event) {
      const item = event.target.closest('.mm-canvas-item');
      if (!item || !modal.contains(item)) return;
      const slotKey = item.getAttribute('data-object-slot');
      const objectId = item.getAttribute('data-object-id');
      const state = normalizeSlotState(slotKey, builder.slots[slotKey]);
      builder.activeSlot = slotKey;
      builder.activeView = PRINT_ZONES[slotKey].view;
      state.selectedId = objectId;
      item.parentElement.querySelectorAll('.mm-canvas-item').forEach(function (entry) {
        entry.classList.toggle('selected', entry === item);
      });
      if (event.target.closest('[data-object-resize]')) beginPointerSession(event, 'resize', slotKey, objectId, item);
      else if (event.target.closest('[data-object-rotate]')) beginPointerSession(event, 'rotate', slotKey, objectId, item);
      else if (!event.target.closest('[data-object-delete], [data-object-duplicate]')) beginPointerSession(event, 'drag', slotKey, objectId, item);
    });

    window.addEventListener('pointermove', updatePointerSession, { passive: false });
    window.addEventListener('pointerup', endPointerSession);
    window.addEventListener('pointercancel', endPointerSession);

    saveBtn.addEventListener('click', function () {
      if (saveBtn.disabled) return;
      savedItems.push({
        color: builder.color,
        size: builder.size,
        baseLayout: builder.baseLayout,
        sleeves: builder.sleeves.slice(),
        slots: cloneSlotsForSave(),
        title: PRODUCT_TITLE,
        image: PRODUCT_IMAGE,
        price: BASE_PRICE,
        qty: 1
      });
      if (savedCounter) savedCounter.textContent = `You've saved ${savedItems.length} custom shirt${savedItems.length === 1 ? '' : 's'}`;
      updateSavedCounterDisplay();
      if (postButtons) {
        postButtons.style.display = 'block';
        postButtons.classList.add('show');
      }
      resetBuilder();
      closeModal();
    });

    addAnotherBtn?.addEventListener('click', function () {
      resetBuilder();
      openModal();
    });

    addToCartBtn?.addEventListener('click', async function () {
      if (!savedItems.length) {
        alert('Save at least one customized shirt first.');
        return;
      }
      if (!VARIANT_ID) {
        alert('The shirt product variant is missing.');
        return;
      }

      const button = addToCartBtn;
      const oldText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';

      try {
        const batch = savedItems.slice();
        const groupBase = `shirt-${Date.now()}`;
        for (let index = 0; index < batch.length; index += 1) {
          await addSavedItemToCart(batch[index], `${groupBase}-${index}`);
        }

        const drawerItems = batch.map(function (item) {
          const summary = Object.keys(item.slots).map(function (slotKey) {
            const slot = item.slots[slotKey] || {};
            const objects = Array.isArray(slot.objects) ? slot.objects.filter(validDesignObject) : [];
            const textObjects = objects.filter(function (object) { return object.type === 'text'; });
            const artObjects = objects.filter(function (object) { return object.type === 'logo'; });
            const parts = [];
            if (textObjects.length) parts.push(textObjects.map(function (object) { return object.text; }).join(', '));
            if (artObjects.length) parts.push(`${artObjects.length} artwork${artObjects.length === 1 ? '' : 's'}`);
            return `${SLOT_META[slotKey].label}: ${parts.join(' + ') || 'Design'}`;
          }).join(' | ');
          return {
            title: PRODUCT_TITLE,
            image: PRODUCT_IMAGE,
            price: BASE_PRICE,
            qty: 1,
            color: item.color,
            size: item.size,
            text: summary
          };
        });

        savedItems = [];
        if (savedCounter) savedCounter.textContent = "You've saved 0 custom shirts";
        updateSavedCounterDisplay();
        if (postButtons) postButtons.style.display = 'none';
        button.disabled = false;
        button.textContent = oldText;

        if (typeof window.openATCDrawer === 'function') window.openATCDrawer(drawerItems);
        else window.location.href = '/cart';
      } catch (error) {
        console.error(error);
        alert('The customized shirt could not be added. Please try again.');
        button.disabled = false;
        button.textContent = oldText;
      }
    });

    buildLayoutUI();
    buildPreviewRail();
    buildInlineToolbar();
    ensureSleeveImageWraps();
    resetBuilder();
    closeModal();
    window.addEventListener('resize', scheduleResponsivePreviewUpdate);
    window.visualViewport?.addEventListener('resize', scheduleResponsivePreviewUpdate);
    window.addEventListener('pageshow', closeModal);
  });
})();
